import {
  AutoComplete,
  ReadOnly,
  useEntityPermission,
  useDataProvider,
} from '@ui-framework/index';
import { observer } from 'mobx-react';
import { useEffect, useState, forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

const ProductLine = forwardRef(
  ({ overwriteProps = {}, field, onChange, ...props }, ref) => {
    const nameKey = 'productLineName';
    const valueKey = 'id';

    const provider =
      process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
    const { get, getApiUrl } = useDataProvider(provider);
    const [defaultOptions, setDefaultOptions] = useState([]);

    const { setValue, getValues, watch } = useFormContext();

    const currentValue = getValues(field?.name);

    const industry = watch(field?.dependencies?.industry || 'undefined');

    const getProductLine = async ({ industryId, searchValue }) => {
      const searchParamm = searchValue ? `&productLineName=${searchValue}` : '';
      const result = await get(
        `${getApiUrl()}/sxcl/v1/industries/${industryId}/product-lines/?limit=10${searchParamm}`,
      );
      if (result.ok) {
        const productLineResult =
          result?.data?.data?.map(item => ({
            label: item[nameKey],
            value: item[valueKey],
          })) || [];
        return productLineResult;
      }
      return null;
    };

    const loadOptions = async (searchValue, callback) => {
      if (!searchValue) return [];
      const resultsData = await getProductLine({
        industryId: industry?.value,
        searchValue,
      });
      if (resultsData) {
        return callback(resultsData);
      }
      return callback([]);
    };

    useEffect(() => {
      setDefaultOptions([]);
      if (currentValue?.value) {
        setValue(field.name, { label: '', value: '' });
      }
    }, [JSON.stringify(industry)]);

    const { isHidden, isReadOnly } = useEntityPermission();

    if (isReadOnly(props?.permission, currentValue)) {
      return (
        <ReadOnly name={props?.name}>
          {currentValue?.label || currentValue?.[nameKey]}
        </ReadOnly>
      );
    }

    if (isHidden(props?.permission)) {
      return (
        <input
          type="hidden"
          name={props?.name}
          value={currentValue?.value || ''}
        />
      );
    }

    return (
      <AutoComplete
        ref={ref}
        defaultOptions={defaultOptions}
        loadOptions={loadOptions}
        {...props}
        overwriteProps={overwriteProps}
        isClearable
      />
    );
  },
);

export default observer(ProductLine);
